import React from "react";
import { ExternalLink } from "lucide-react";

import { Button } from "@/design-system/components/Button/Button";
import { Typography } from "@/design-system/components/Typography/Typography";
import { WizardStepLayout } from "@/wizards/framework/WizardStepLayout";
import { EnableDestinationStepProps } from "../stepProps";

export function ConfirmInDestinationStep({
  context,
  updateData,
  minimize,
  complete,
}: EnableDestinationStepProps) {
  const name = context.saasDestination?.name ?? "the destination";
  const docsURL = context.saasDestination?.docsURL;

  return (
    <WizardStepLayout
      title={`Confirm events in ${name}`}
      description={`Most destinations take a while to process events. Check back in ${name} later to confirm they arrived.`}
      secondaryActions={
        <>
          <Button variant="outline" onClick={minimize}>
            Minimize and check later
          </Button>
          <Button variant="outline" onClick={complete}>
            Finish without confirming
          </Button>
        </>
      }
      primaryAction={{
        label: `I see events in ${name}`,
        onClick: () => {
          updateData({ confirmedInDestination: true });
          complete();
        },
      }}
    >
      <Typography variant="body-sm" color="subtle">
        Your progress is saved. Open this wizard again from the bottom-right
        corner of the screen or the command bar (⌘K or Ctrl+K) when you’re
        ready.
      </Typography>
      {docsURL && (
        <Typography variant="body-sm">
          <a
            href={docsURL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-textActionSelected inline-flex cursor-pointer items-center gap-1 underline"
          >
            Setup guide for {name}
            <ExternalLink
              className="size-icon-sm"
              strokeWidth={2}
              aria-hidden
            />
          </a>
        </Typography>
      )}
    </WizardStepLayout>
  );
}
